export const ROLES_TYPE = {
  MANUAL_SWAP: "manual_swap",
  MANUAL_SWAP_DIGITAL: "digital_twin",
  MANUAL_SWAP_INVENTORY: "inventory",
  MANUAL_SWAP_OTA: "ota",
  CASH_COLLECTION: "cash_collection",
  BATTERY_MOVEMENT: "battery_movement",
  EMI_CALCULATOR: "emi_calculator",
  ONBOARDING: "onboarding",
  DRIVER_LEAD_CREATION: "driver_lead_creation",
  DRIVER_LEAD_VIEW: "driver_lead_view",
  DEALER: "dealer",
};

export const ROLES = {
  MANUAL_SWAP: ROLES_TYPE.MANUAL_SWAP,
  ADMIN: "admin",

  MANUAL_DIGITAL: `${ROLES_TYPE.MANUAL_SWAP}.${ROLES_TYPE.MANUAL_SWAP_DIGITAL}`,
  MANUAL_INVENTORY: `${ROLES_TYPE.MANUAL_SWAP}.${ROLES_TYPE.MANUAL_SWAP_INVENTORY}`,
  MANUAL_OTA: `${ROLES_TYPE.MANUAL_SWAP}.${ROLES_TYPE.MANUAL_SWAP_OTA}`,

  CASH_COLLECTION: ROLES_TYPE.CASH_COLLECTION,
  BATTERY_MOVEMENT: ROLES_TYPE.BATTERY_MOVEMENT,
  EMI_CALCULATOR: ROLES_TYPE.EMI_CALCULATOR,
  ONBOARDING: ROLES_TYPE.ONBOARDING,
  DRIVER_LEAD_CREATION: ROLES_TYPE.DRIVER_LEAD_CREATION,
  DRIVER_LEAD_VIEW: ROLES_TYPE.DRIVER_LEAD_VIEW,
  DEALER: ROLES_TYPE.DEALER,
};
